/** Состояние сети. Веб-реализация поверх navigator.onLine. */
export const isOnline = () => globalThis.navigator?.onLine ?? true

/** @param {(online: boolean) => void} cb @returns {() => void} отписка */
export function subscribe(cb) {
  const on = () => cb(true)
  const off = () => cb(false)
  globalThis.addEventListener?.('online', on)
  globalThis.addEventListener?.('offline', off)
  return () => {
    globalThis.removeEventListener?.('online', on)
    globalThis.removeEventListener?.('offline', off)
  }
}
